import React from 'react';
import PropTypes from 'prop-types';

import ActiveStep from './ActiveStep';
import StepsNav from './StepsNav';
import SideNav from '../siteNav/SideNav';

class StepsLayout extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      completed: {},
      activeId: props.stepDefinitions[0].id,
    };

    this.handleActivate = this.handleActivate.bind(this);
    this.handleComplete = this.handleComplete.bind(this);
    this.handleNextStep = this.handleNextStep.bind(this);
    this.handleResetSteps = this.handleResetSteps.bind(this);

    this.createStepsFromDefinitions = this.createStepsFromDefinitions.bind(this);
    this.isUnlocked = this.isUnlocked.bind(this);
    this.dependenciesAreCompleted = this.dependenciesAreCompleted.bind(this);
  }

  componentDidMount() {
    this.mounted = true;
  }

  componentWillUnmount() {
    this.mounted = false;
  }

  createStepsFromDefinitions() {
    return this.props.stepDefinitions.map(definition => ({
      ...definition,
      completed: this.state.completed[definition.id],
      locked: !this.isUnlocked(definition),
    }));
  }

  isUnlocked(step) {
    const { dependencyIds } = step;
    return this.dependenciesAreCompleted(dependencyIds);
  }

  dependenciesAreCompleted(ids) {
    const { completed } = this.state;
    return ids.filter(id => completed[id]).length === ids.length;
  }

  handleActivate(id) {
    // Don't need to mark as active if already active.
    if (this.mounted && this.state.activeId !== id) {
      this.setState({ activeId: id });
    }
  }

  async handleComplete(id, navigateToNextStep = false) {
    const { completed } = this.state;
    // Don't need to mark as completed if already completed.
    if (!this.state.completed[id]) {
      if (this.mounted) {
        this.setState({ completed: { ...completed, [id]: true } }, () => {
          if (navigateToNextStep) {
            this.handleNextStep(id);
          }
        });
      }
    } else if (navigateToNextStep) {
      // Still move to next step if desired.
      this.handleNextStep(id);
    }
  }

  handleNextStep(id) {
    const steps = this.createStepsFromDefinitions();

    // Find the index of the given step id.
    const stepIndex = steps.map(step => step.id).indexOf(id);
    // Find any unlocked steps after the given step.
    const nextSteps = steps.filter((step, index) => !step.locked && index > stepIndex);
    // Make the next unlocked step active.
    if (this.mounted && nextSteps.length) {
      this.setState({ activeId: nextSteps[0].id });
    }
  }

  handleResetSteps() {
    this.setState({
      completed: {},
      activeId: this.props.stepDefinitions[0].id,
    });
  }

  render() {
    const {
      navItems, stepDefinitions, stepsSubNavPath, stepsHeader,
    } = this.props;
    const { activeId } = this.state;
    const activeStep = stepDefinitions.filter(definition => definition.id === activeId)[0];
    const steps = this.createStepsFromDefinitions();

    let sideNav;
    if (navItems.length) {
      const stepsSubNav = (
        <StepsNav steps={steps} onActivate={this.handleActivate} activeId={this.state.activeId} />
      );
      sideNav = (
        <SideNav navItems={navItems} stepsSubNavPath={stepsSubNavPath} stepsSubNav={stepsSubNav} />
      );
    } else {
      sideNav = (
        <StepsNav
          steps={steps}
          onActivate={this.handleActivate}
          header={stepsHeader || activeStep.name}
          activeId={this.state.activeId}
        />
      );
    }

    return (
      <div className="steps-layout">
        {sideNav}
        {activeStep && (
          <ActiveStep
            {...this.props}
            component={activeStep.component}
            header={activeStep.name}
            id={activeStep.id}
            completed={activeStep.completed}
            onComplete={this.handleComplete}
            onNextStep={this.handleNextStep}
            onResetSteps={this.handleResetSteps}
          />
        )}
      </div>
    );
  }
}

StepsLayout.displayName = 'StepsLayout';

StepsLayout.defaultProps = {
  navItems: [],
  stepsSubNavPath: '',
  stepsHeader: '',
};

StepsLayout.propTypes = {
  stepDefinitions: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
  })).isRequired,
  navItems: PropTypes.arrayOf(PropTypes.shape({
    text: PropTypes.string,
    path: PropTypes.string,
  })),
  stepsSubNavPath: PropTypes.string,
  stepsHeader: PropTypes.string,
};

export default StepsLayout;



// WEBPACK FOOTER //
// ./src/components/steps/StepsLayout.js